import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as bffConst from '@app/shared/constants/communications';
import { AppConfigService as appConfig } from '@app/app.config';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
    private appConfig = inject(appConfig);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modifiedReq = req.clone({
            headers: req.headers.set(bffConst.HEADER_APIKEY_NAME, this.appConfig.bffApiKey),
        });
        return next.handle(modifiedReq);
    }
}
